import { Component, OnInit, Inject } from "@angular/core";
import { PickingService } from "src/app/servicios/picking.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

@Component({
  selector: "app-dialog-detalle-picking",
  templateUrl: "./dialog-detalle-picking.component.html",
  styleUrls: ["./dialog-detalle-picking.component.css"],
})
export class DialogDetallePickingComponent implements OnInit {
  loadingPedidos = false;
  pedidos = [];
  cantidadPicking: any;
  cantidadTotalPedido = 0;
  deshabilitado = true;

  respuestaDetalle = [];

  constructor(
    private servicioPicking: PickingService,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogDetallePickingComponent>
  ) {
    let params = dataDialog;
    let paramBusqueda = {
      encabezados: params.encabezados,
    };
    this.cantidadPicking = params.cantidadPicking;
    this.loadingPedidos = true;
    this.servicioPicking
      .postBuscarProductoPicking(paramBusqueda, params.idProducto)
      .subscribe((data) => {
        this.pedidos = data;
        this.loadingPedidos = false;
        this.pedidos.forEach((el) => {
          this.cantidadTotalPedido += el.cantidad;
        });
      });
  }

  ngOnInit() {}

  onKey(item, event) {
    //REVISO ES UN VALOR NUMERICO O NO ESTA VACIO
    if (isNaN(event.target.value) || !event.target.value) {
      Swal.fire(
        "Valor no aceptado!",
        "Debe ingresar un valor númerico.",
        "error"
      );

      return;
    }

    if (this.respuestaDetalle.length == 0) {
      //SI EL ARRAY ESTA EN CERO INSERTO EL VALOR AL ARRAY
      this.respuestaDetalle.push([
        item.idDetalle,
        parseInt(event.target.value),
        item.idProducto,
      ]);
    } else {
      // SI EL ARRAY CONTIENE DATOS VALIDO QUE ESTE MISMO ITEM NO EXISTE Y EN CASO DE QUE SI SE MODIFICA
      let existe = false;
      this.respuestaDetalle.forEach((el, idx) => {
        if (el[0] == item.idDetalle) {
          this.respuestaDetalle[idx][1] = parseInt(event.target.value);
          existe = true;
        }
      });

      if (!existe) {
        this.respuestaDetalle.push([
          item.idDetalle,
          parseInt(event.target.value),
          item.idProducto,
        ]);
      }
    }

    this.pedidos.forEach((el, idx) => {
      if (el.idDetalle == item.idDetalle) {
        this.pedidos[idx].cantidadDespacho = parseInt(event.target.value);
      }
    });

    this.cantidadTotalPedido = 0;
    this.pedidos.forEach((el) => {
      this.cantidadTotalPedido += parseInt(el.cantidadDespacho);
    });

    if (this.cantidadTotalPedido == this.cantidadPicking) {
      this.deshabilitado = false;
    } else {
      this.deshabilitado = true;
    }
    //console.log(this.respuestaDetalle);
  }

  cerrar(origen) {
    if (origen == "cancelar") {
      this.dialogRef.close({ origen: origen, data: "" });
    } else {
      this.dialogRef.close({ origen: origen, data: this.respuestaDetalle });
    }
  }
}
